<template>
	<div style="background-color:#FFF">
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center">
				<h3 class="order-title" style="padding: 30px 0">ព្រះរាជាណាចក្រកម្ពុជា<br>ជាតិ សាសនា ព្រះមហាក្សត្រ</h3>
				<h3 class="order-title" style="padding: 30px 0">កិច្ចសន្យាកម្ចីប្រាក់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100" style="padding: 10px 100px">
				<p style="text-align: left;">ខ្ញុំបាទឈ្មោះ ABCD អាយុ ២៧ឆ្នាំ កាន់អត្តសញ្ញាណប័ណ្ណ សញ្ជាតិខ្មែរលេខ
					ABCD ចុះថ្ងៃទី15 ខែ 02 ឆ្នាំ​ 2016 មានទីលំនៅផ្ទះ លេខ 50ដេ ផ្លូវ៣៥២អា សង្កាត់ច្រាំងចំរះ១ ខណ្ឌឬស្សីកែវ
					រាជធានី ហៅកាត់ថា ភាគី “ក” ជាអ្នកអោយកម្ចីប្រាក់។</p>
				<p style="text-align: center;">និង</p>
				<p style="text-align: left;"><span v-if="loan.gender == 'f'">នាង</span>ខ្ញុំឈ្មោះ {{loan.name_khmer}}
					កាន់អត្តសញ្ញាណប័ណ្ណ សញ្ជាតិខ្មែរលេខ
					{{loan.id_card}} មានអាសយដ្ឋាន{{loan.address}} ហៅកាត់ថា ភាគី “ខ” ជាអ្នកខ្ចីប្រាក់ ។</p>
				<p style="text-align: left;padding: 30px 0px">ភាគី “ក” និង ភាគី “ខ” បានព្រមព្រៀងតាមប្រការដូចខាងក្រោម៖</p>

				<p style="text-align: left;">ប្រការ១៖ ភាគី ក យល់ព្រមឲ្យភាគី ខ ខ្ចីប្រាក់ចំនួន​
					{{config.moneylify(loan.amount)}} ដុល្លារ​អាមេរិក</p>

				<p style="text-align: left;">ប្រការ២៖ ភាគី ខ យល់ព្រមបង់ប្រាក់ជូនភាគី ក តាមតារាងខាងក្រោមដោយគោរព   
					តាមកាលបរិច្ឆេទ និង ទឹកប្រាក់អោយបានខ្ជប់ខ្ជូន។</p>

				<p style="text-align: left;">ប្រការ៣៖ ក្នុងករណី ភាគី ខ មានការបង់យឺតយ៉ាវលើសពី ៣ ថ្ងៃត្រូវជូនដំណឹងមកភាគី ក
					ឲ្យបានដឹង ហើយបើយឺតយ៉ាវក្នុងការបង់ប្រាក់លើសពី ៧ថ្ងៃ ភាគី ខ យល់ព្រមបង់ប្រាក់ផាកពិន័យ ៣ភាគរយ
					នៃថ្លៃបង់ប្រាក់ប្រចាំខែ ជូនភាគី ក។ ក្នុងករណីខកខានបង់ប្រាក់ប្រចាំខែជូនភាគី ក ចាប់ពី ១ខែ រហូតដល់ ៣ខែ, ភាគី
					ខ ត្រូវជូនដំណឹងទៅភាគី ក យ៉ាងតិច ១សប្តាហ៍មុនថ្ងៃបង់ប្រាក់។</p>

				<p style="text-align: left;">ប្រការ៤៖ ក្នុងករណី ភាគី ខ មិនមានអាចទំនាក់ទំនងបាន ឬមានការគេចវេសសងកម្ចីប្រចាំខែ
					ជូនភាគី ក លើសពី ៣ខែ, ភាគី ក មានសិទ្ធរឹបអូសទ្រព្យបញ្ចាំ និងផ្សាយជាសាធារណៈនូវអត្តសញ្ញាណភាគី ខ
					ទៅកាន់សាធារណជន។ </p>

			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="width:100%">
					<tr>
						<td class="center">ស្នាមមេដៃម្ចាស់កម្ចី</td>
						<td class="center">ស្នាមមេដៃកូនកម្ចី</td>
						<td class="center" v-for="guarantor in guarantorList">ស្នាមមេដៃអ្នកធានា</td>
					</tr>
					<tr style="height: 120px">
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td class="center">ABCD</td>
						<td class="center">{{ loan.name_khmer }}</td>
						<td class="center" v-for="guarantor in guarantorList">{{ guarantor.name_khmer }}</td>
					</tr>
				</table>
				<!-- <md-table>
					<md-table-row class="no-hover" style="border: 0px">
						<md-table-cell class="center">ស្នាមមេដៃម្ចាស់កម្ចី</md-table-cell>
						<md-table-cell class="center-right">ស្នាមមេដៃកូនកម្ចី</md-table-cell>
						<md-table-cell class="center-right">ស្នាមមេដៃកូនកម្ចី</md-table-cell>
					</md-table-row>
					<md-table-row class="no-hover">
						<md-table-cell style="text-align: center;height: 120px;border: 0px !important"></md-table-cell>
						<md-table-cell style="text-align: center;height: 120px;border: 0px !important"></md-table-cell>
					</md-table-row>
					<md-table-row class="no-hover">
						<md-table-cell class="center">សុខ វុទ្ធី</md-table-cell>
						<md-table-cell class="center-right">{{ loan.name_khmer }}</md-table-cell>
						<md-table-cell class="center-right">{{ loan.name_khmer }}</md-table-cell>
					</md-table-row>
				</md-table> -->
				<!-- e -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.getLoan();
		},
		mounted() { },
		data() {
			return {
				loaded: false,
				paymentList: [],
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					name_khmer: "",
					address: "",
					id_card: "",
					phone: "",
					gender: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
				guarantorList: []
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash).then(data => {
					this.loan = data.body.data
					this.loaded = true
					setTimeout(() => {
							window.print();
					}, 1000)
				})
			},
		}
	}
</script>

<style>
	.no-hover:hover {
		background-color: #FFF !important;
	}
	.center {
		text-align: center;
	}
	.center-right {
		display: flex;
		justify-content: center;
		border: 0px !important;
	}

	body {
		background-color: #FFF !important;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintLoanContract.vue